import React, { useState } from 'react';

export function IconClose({
  className = '',
  style = {},
  clickable = false,
}: {
  className?: string;
  style?: React.CSSProperties;
  clickable?: boolean;
}) {
  const [hovered, setHovered] = useState(false);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className={className}
      style={{
        ...style,
        transform: hovered && clickable ? 'scale(1.2)' : 'scale(1)',
        transition: clickable ? 'transform 0.2s ease-in-out' : undefined,
        display: 'inline-block',
        cursor: clickable ? 'pointer' : 'default',
      }}
      onMouseEnter={() => clickable && setHovered(true)}
      onMouseLeave={() => clickable && setHovered(false)}
    >
      <path d="M4 16H8L8 12H4L4 16Z" fill="white" />
      <path d="M0 20H4L4 16H0L0 20Z" fill="white" />
      <path d="M8 11.9999H12V7.99992H8L8 11.9999Z" fill="white" />
      <path d="M4 8.00008H8L8 4.00008H4L4 8.00008Z" fill="white" />
      <path d="M0 4.00004L4 4.00004L4 3.8147e-05L0 3.8147e-05L0 4.00004Z" fill="white" />
      <path d="M16 11.9999H12V15.9999H16V11.9999Z" fill="white" />
      <path d="M20 16H16V20H20V16Z" fill="white" />
      <path d="M16 4.00004H12V8.00004H16V4.00004Z" fill="white" />
      <path d="M20 0H16V4H20V0Z" fill="white" />
    </svg>
  );
}
